import { StyledRange } from 'components/DatePickerStyles/DatePickerStyles'
import Input from 'components/Form/Input'
import Label from 'components/Form/Label'
import CalendarIcon from 'components/icons/CalendarIcon'
import SeperatorIcon from 'components/icons/SeperatorIcon'
import Select from 'components/Select'
//import SelectMultiple from 'components/Form/SelectNewMulti'
import SelectShort from 'components/Select/SelectShort'
import {
  FormItem,
  SectionHeading,
} from 'modules/Students/Partials/AddNewStudentDrawer/Style/style'
import React, { useEffect, useState, useCallback } from 'react'
import { getEligibilityCriteria } from 'modules/Events/actions'
import { useDispatch } from 'react-redux'
import { toCamelCase } from '../../../../../../utils/helpers'
import { Select as SelectMultipleItem } from "antd";
import styled from 'styled-components'

const SelectMultiple = styled(SelectMultipleItem)`
.ant-select-selector{
height: auto !important;
min-height: 40px !important;
border-radius: 10px !important;
}
`


const { Option } = Select;
const CourseDetails = ({
  degreeOptions,
  studentType,
  studentBatch,
  setStudentBatch,
  setMarksType,
  setSpecialization,
  specialization,
  formId,
  form,
  singleStudentData,
  setCourseId,
  title,
  newStudentDrawer,
  specializationList,
  setSpecializationList,
  showSpecialization,
  setShowSpecialization,
}) => {
  const dispatch = useDispatch()
  const [degrees, setDegrees] = useState([])
  const [departments, setDepartments] = useState([])
  const { DEPARTMENT_ID } = process.env
  const [courseData, setCourseData] = useState(null)
  // Initialize with specialization if it exists and is an array
  const [selectedItems, setSelectedItems] = useState(Array.isArray(specialization) ? specialization : []);

  // Initialize the form with existing data on mount
  useEffect(() => {
    
    // Set initial form values for specialization if available
    if (form && specialization?.length > 0) {
      form.setFieldsValue({
        specialisation: specialization.map(s => s.name),
        specialisationData: specialization
      });
    }
    
    // Handle editing existing student data
    if (form && singleStudentData?.specialisation && !specialization?.length) {
      try {
        const specialisationNames = singleStudentData.specialisation.split(',').map(s => s.trim());
        const specialisationIds = singleStudentData.specialisationId?.split(',').map(s => s.trim()) || [];
        
        // Create specialization objects
        const specialisationObjects = specialisationNames.map((name, index) => ({
          name,
          id: specialisationIds[index] || ''
        }));
        
        // Set both the form fields and local state
        form.setFieldsValue({
          specialisation: specialisationNames,
          specialisationData: specialisationObjects
        });
        
        setSelectedItems(specialisationObjects);
        if (setSpecialization) {
          setSpecialization(specialisationObjects);
        }
      } catch (error) {
        console.error('Error setting initial specialization data:', error);
      }
    }
  }, []);

  // Extract selected IDs from full objects (needed by <Select>)
  const [selectedIds, setSelectedIds] = useState([]);
  
  // Update the form and state when selections change
  const handleChange = (selectedValue) => {
    
    
    // Direct update of selectedIds - ensures consistent ID format
    // First ensure we have only valid IDs
    const cleanSelectedIds = Array.isArray(selectedValue) ? 
      selectedValue.filter(val => typeof val === 'string') : 
      (selectedValue ? [selectedValue] : []);
      
    
    setSelectedIds(cleanSelectedIds);
    
    // Always work with arrays for consistency
    const valueArray = cleanSelectedIds;
    
    // Map selected IDs to full objects from the list
    const selectedPayload = [];
    
    // Find matching objects from specializationList
    if (specializationList && specializationList.length) {
      // For each selected ID, try to find by ID or by name
      valueArray.forEach(value => {
        // First try to match by ID (normal case)
        let matchingItem = specializationList.find(item => item.id === value);
        
        // If not found, try to match by name (handles case when a name was passed instead of ID)
        if (!matchingItem) {
          matchingItem = specializationList.find(item => item.name === value);
        }
        
        if (matchingItem) {
          // Avoid duplicate entries
          if (!selectedPayload.some(item => item.id === matchingItem.id)) {
            selectedPayload.push(matchingItem);
          }
        }
      });
    }
    
    
    
    // Update local state
    setSelectedItems(selectedPayload);
    
    // Update parent component state if available
    if(setSpecialization) {
      setSpecialization(selectedPayload);
    }
    
    // Update form fields if form exists
    if (form) {
      // Update both form fields
      const formUpdate = {
        specialisationData: selectedPayload,
        specialisation: selectedPayload.map(s => s.name)
      };
      
      form.setFieldsValue(formUpdate);
      
      // Also update selectedIds state to keep the UI in sync
      const newSelectedIds = selectedPayload.map(item => item.id);
      setSelectedIds(newSelectedIds);
    }
  };
  
  // Update local state when specializationList changes
  useEffect(() => {
    if (specializationList?.length > 0) {
      // Initial setup of selectedItems if not already set
      if (!selectedItems.length && specialization?.length > 0) {
        setSelectedItems(specialization);
      }
      
      // If editing an existing record with specialization data
      if (singleStudentData?.specialisation) {
        try {
          // Handle the case where we need to parse the specialisation strings
          const currentSpecializations = singleStudentData.specialisation.split(',');
          const currentSpecializationIds = singleStudentData.specialisationId?.split(',') || [];
          
          // Map to objects with name and id
          const mappedSpecializations = currentSpecializations.map((name, index) => ({
            name: name.trim(),
            id: currentSpecializationIds[index]?.trim() || ''
          }));
          
          setSelectedItems(mappedSpecializations);
        } catch (error) {
          console.error('Error parsing specialization data:', error);
        }
      }
    }
  }, [specializationList]);
  const fetchDegree = async (searchValue = '') => {
    const response = await dispatch(
      getEligibilityCriteria({
        searchValue: searchValue?.trim(),
        searchType: 'ALL',
        searchField: [],
      })
    )
    const transformedData = transformApiData(response)
    setDegrees(transformedData)
  }

  const fetchDepartment = async (searchValue = '', degreeId = '') => {
    const response = await dispatch(
      getEligibilityCriteria({
        searchValue: searchValue?.trim(),
        searchType: 'STREAM',
        searchField: [],
        degreeId: degreeId,
      })
    )
    const transformedData = transformApiData(response)
    setDepartments(transformedData?.[0]?.stream || [])
  }

  const fetchSpecialisation = async (
    searchValue = '',
    degreeId = '',
    departmentId = ''
  ) => {
    const response = await dispatch(
      getEligibilityCriteria({
        searchValue: searchValue?.trim(),
        searchType: 'SPECIALISATION',
        searchField: [],
        degreeId: degreeId,
        departmentId: departmentId,
      })
    )
    const transformedData = transformApiData(response)
    let specialisation = transformedData?.[0]?.stream?.[0]?.specialisation?.map(
      course => {
        return course?.specialisation
      }
    )
    setSpecializationList(specialisation || [])
    // Set showSpecialization to true only if we have data and it hasn't been set before
    if (specialisation?.length > 0 && !showSpecialization) {
      setShowSpecialization(true)
    }
  }
  useEffect(() => {
    // if(title ==='Edit & Update Student'){
    //   setShowSpecialization(true);
    // }
    fetchDegree()
  }, [title])
  useEffect(() => {
    setShowSpecialization(false)
    setSpecializationList([])
  }, [newStudentDrawer])
  useEffect(() => {
    if (form.getFieldValue('degreeId'))
      fetchDepartment('', form.getFieldValue('degreeId'))
  }, [form.getFieldValue('degreeId')])
  useEffect(() => {
    if (form.getFieldValue('degreeId') && form.getFieldValue('streamId'))
      fetchSpecialisation(
        '',
        form.getFieldValue('degreeId'),
        form.getFieldValue('streamId')
      )
    // if (
    //   form.getFieldValue('specialisation') !== null &&
    //   form.getFieldValue('specialisation') !== undefined &&
    //   form.getFieldValue('specialisation') !== ''
    // ) {
    //   setShowSpecialization(true)
    // }
  }, [form.getFieldValue('streamId')])

  useEffect(() => {
    if (form.getFieldValue('degreeId') && !courseData) {
      let courseId = degreeOptions?.find(
        item => item.id === form.getFieldValue('degreeId')
      )
      setCourseData(courseId?.stream)
    }
  }, [form.getFieldValue('degreeId'), degreeOptions])

  function transformApiData(data) {
    return data.map(degree => {
      const specialisationList =
        degree.streams?.flatMap(
          stream =>
            stream.specialisations?.map(spec => ({
              specialisation: {
                id: spec?.specialisationId || null,
                name: spec?.specialisationName
                  ? spec.specialisationName.charAt(0).toUpperCase() +
                    spec.specialisationName.slice(1).toLowerCase()
                  : null,
                status: spec?.specialisationStatus || null,
              },
            })) || []
        ) || []

      return {
        id: degree?.degreeId || null,
        degreeId: degree?.degreeId || null,
        domainId: degree?.domainId || null,
        domain: degree?.domainName?.toLowerCase()?.replace(/\b\w/g, char => char?.toUpperCase()) || null,
        name: degree?.degreeName?.toLowerCase()?.replace(/\b\w/g, char => char?.toUpperCase()) || null,
        status: degree?.degreeStatus || null,
        shortForm: degree?.degreeShortForm || null,
        type: degree?.type || null,
        stream:
          degree.streams?.map(stream => ({
            id: stream?.streamId || null,
            name: stream?.streamName?.toLowerCase()?.replace(/\b\w/g, char => char?.toUpperCase()) || null,
            status: stream?.streamStatus || null,
            specialisation:
              stream.specialisations?.map(spec => ({
                specialisation: {
                  id: spec?.specialisationId || null,
                  name: spec?.specialisationName
                    ? spec.specialisationName.charAt(0).toUpperCase() +
                      spec.specialisationName.slice(1).toLowerCase()
                    : null,
                  status: spec?.specialisationStatus || null,
                },
              })) || [],
            degreeStreamMapId: degree?.degreeStreamId || null,
          })) || [],
        examType: null,
        duration: null,
        specialisation: specialisationList,
        degreeStreamMapId: degree?.degreeStreamId || null,
      }
    })
  }

  const onBatchChange = (value, years) => {
    setStudentBatch({
      startedOn: years[0],
      endedOn: years[1],
    })
  }
  useEffect(() => {
    checkDepartment()
  }, [form.getFieldValue('degreeId')])
const checkDepartment = () => {
  let courseId = courseData?.find(item => item.id === DEPARTMENT_ID)
  console.log(courseId,'courseId')
  if(courseId){
    form?.setFieldsValue({ degreeStreamMapId: courseId?.degreeStreamMapId })
    form?.setFieldsValue({ department: 'Management' })
    form?.setFieldsValue({ streamId: DEPARTMENT_ID })
    form?.setFieldsValue({ specialisation: [] })
  }
}

  const onDegreeChange = (e, option) => {
    if (option?.option) {
      setDepartments([])
      setCourseId(option.option?.degreeId)

      form?.setFieldsValue({ degreeId: option.option?.id })
      form?.setFieldsValue({ degree: option.option?.name })
      form?.setFieldsValue({ domainId: option.option?.domainId })
      form?.setFieldsValue({ domain: option.option?.domain })
      form?.setFieldsValue({ educationLevel: option?.option?.type })
      form?.setFieldsValue({ specialisationId: [] })
      let courseId = degreeOptions?.find(item => item.id === option?.option?.id)
      setCourseData(courseId?.stream)
      form?.setFieldsValue({ courseId: courseId?.degreeId })
      let { duration, examType, id, type } = option.option

      let updatedList = option.option?.stream?.map(stream => {
        return {
          ...stream,
          duration,
          examType,
          streamId: id,
          type,
        }
      })

      setDepartments(updatedList)

      setMarksType(e)
      form?.setFieldsValue({ department: '' })
      form?.setFieldsValue({ specialisation: [] })
      setShowSpecialization(false)
      setSpecialization([])
      fetchDegree()
      // if(option?.option?.name?.toLowerCase() === 'master of business administration'){
      //   checkDepartment()
      //   // form?.setFieldsValue({ department: 'Management' })
      //   // form?.setFieldsValue({ streamId: DEPARTMENT_ID })

      // }
    } else {
      setCourseId('')
      form?.setFieldsValue({ courseId: '' })
      form?.setFieldsValue({ degreeId: '' })
      form?.setFieldsValue({ degree: '' })
      form?.setFieldsValue({ domainId: '' })
      form?.setFieldsValue({ domain: '' })
      form?.setFieldsValue({ department: '' })
      form?.setFieldsValue({ streamId: '' })
      form?.setFieldsValue({ specialisation: [] })
      form?.setFieldsValue({ specialisationId: [] })
      setShowSpecialization(false)
      setSpecialization([])
      setCourseData(null)
    }
  }

  const onDepartmentChange = (e, option) => {
    if (option?.option) {
      form?.setFieldsValue({ streamId: option?.option?.id })

      let courseId = courseData?.find(item => item.id === option?.option?.id)
      form?.setFieldsValue({ degreeStreamMapId: courseId?.degreeStreamMapId })
      setSpecializationList([])
      setSpecialization([])
      form?.setFieldsValue({ specialisation: [] })
      setMarksType(option?.option)
      let specialisation = option?.option?.specialisation?.map(course => {
        return course?.specialisation
      })
      setSpecializationList(specialisation)
      form?.setFieldsValue({ specialisationId: [] })
      if (option?.option?.specialisation?.length) {
        setShowSpecialization(true)
      } else {
        setShowSpecialization(false)
        setSpecialization([])
      }
    } else {
      form?.setFieldsValue({ streamId: '' })
      form?.setFieldsValue({ department: '' })
      form?.setFieldsValue({ specialisation: [] })
      form?.setFieldsValue({ degreeStreamMapId: '' })
      setSpecializationList([])
      setShowSpecialization(false)
      setSpecialization([])
      form?.setFieldsValue({ specialisationId: [] })
    }
  }

  const onSpecializatioChange = (e, option) => {
    // Only process valid options (with id and name)
    if (option?.length > 0) {
      const simplifiedOptions = option.map(opt => ({
        id: opt?.id,
        name: opt?.name
      }));
      
      setSpecialization(simplifiedOptions);
      form?.setFieldsValue({ specialisationData: simplifiedOptions })
      fetchSpecialisation(
        '',
        form.getFieldValue('degreeId'),
        form.getFieldValue('streamId')
      )
    } else {
      setSpecialization([]);
      fetchSpecialisation(
        '',
        form.getFieldValue('degreeId'),
        form.getFieldValue('streamId')
      )
    }
  }

  const validateSpecialisation = (rule, value, callback) => {
    if (specialization?.length > 2) {
      
      return Promise.reject(new Error('Maximum 2 Specialisation only allowed'))
    } else {
      return Promise.resolve()
    }
  }
  const delayFunctionToFetch = useCallback(
    debounce(async data => {
      await fetchDegree(data)
    }, 500),
    []
  )

  const delayDepartmentToFetch = useCallback(
    debounce(async data => {
      await fetchDepartment(data, form.getFieldValue('degreeId'))
    }, 500),
    []
  )

  const delaySpecializationToFetch = useCallback(
    debounce(async data => {
      await fetchSpecialisation(
        data,
        form.getFieldValue('degreeId'),
        form.getFieldValue('streamId')
      )
    }, 500),
    []
  )

  function debounce(fn, delay) {
    let timer
    return function () {
      let context = this,
        args = arguments
      clearTimeout(timer)
      timer = setTimeout(() => {
        fn.apply(context, args)
      }, delay)
    }
  }
  return (
    <>
      <SectionHeading>Course Details</SectionHeading>
      {studentType == 'transferred' ? (
        <>
          <Input
            width="100%"
            label="Previous College"
            placeholder="Eg. Aryabhatt Institute of Technology"
            optional={'*'}
            name={'previous_college'}
            rules={[
              {
                required: true,
                message: 'Please enter previous college name!',
              },
            ]}
          />

          <Input
            width="100%"
            label="Previous University"
            placeholder="Eg. Guru Gobind Singh Indraprastha University"
            optional={'*'}
            name={'previous_university'}
            rules={[
              {
                required: true,
                message: 'Please enter previous university name!',
              },
            ]}
          />
        </>
      ) : (
        ''
      )}
      <div>
        <FormItem name="courseId" style={{ height: 0 }} />
        <FormItem name="degreeId" style={{ height: 0 }} />
        <FormItem name="domain" style={{ height: 0 }} />
        <FormItem name="domainId" style={{ height: 0 }} />
        <FormItem name="educationLevel" style={{ height: 0 }} />
        <FormItem name="degreeStreamMapId" style={{ height: 0 }} />

        {}
        <FormItem
          name="degree"
          rules={[{ required: true, message: 'Please select a degree name!' }]}
        >
          <SelectShort
            label="Degree Name*"
            valueParam={'name'}
            placeholder="Eg. Bachlore of Engineering - B.E"
            OptionData={degrees
              ?.filter(option => option?.status === 1)
              ?.map(option => ({
                ...option,
                name: toCamelCase(option?.name),
              }))}
            optionLabelProp="name"
            onChange={onDegreeChange}
            onSearch={data => delayFunctionToFetch(data?.trim())}
            // shortForm={true}
            iskey={true}
            filterOption={false}
            allowClear={true}
          />
        </FormItem>
      </div>

      <div style={{ marginTop: '-30px' }}>
        <FormItem name="streamId" />

        <FormItem
          name="department"
          rules={[
            { required: true, message: 'Please select a department name!' },
          ]}
        >
          <Select
            valueParam={'name'}
            label="Department Name *"
            placeholder="Eg. Computer Science"
            OptionData={departments?.filter(option => option.status === 1)}
            optionLabelProp={'name'}
            onChange={onDepartmentChange}
            disabled={!form.getFieldValue('degreeId')}
            onSearch={data => delayDepartmentToFetch(data?.trim())}
            filterOption={false}
            allowClear={true}
          />
        </FormItem>
      </div>
      {showSpecialization ? (
        <div>
        
<FormItem
  name="specialisationId"
  rules={[{ required: false },
    { validator: validateSpecialisation },
  ]}
>
 
  <Select
    mode="multiple"
            valueParam={'id'}
            nameParam={'name'}
            label="Specialization"
            placeholder="Eg. Computer Science"
            OptionData={specializationList??[]}
            optionLabelProp={'name'}
            onChange={onSpecializatioChange}
            onSearch={data => delaySpecializationToFetch(data?.trim())}
            disabled={!form.getFieldValue('streamId')}
            filterOption={false}
            allowClear={true}
            selectedOptions={specialization?.map(item => item?.id)??[]}
            value={specialization?.map(item => item?.id)??[]}
          />
</FormItem>


        </div>
      ) : null}
      <div>
        <Label required={true}>
          Batch <span>*</span>
        </Label>
        <FormItem
          name="batch"
          rules={[
            { type: 'array', required: true, message: 'Please select batch!' },
          ]}
        >
          <StyledRange
            width="60%"
            picker="month"
            placeholder={['YYYY-MM', 'YYYY-MM']}
            separator={<SeperatorIcon />}
            suffixIcon={<CalendarIcon />}
            onChange={onBatchChange}
          />
        </FormItem>
      </div>
    </>
  )
}

export default CourseDetails
